/** @typedef {{ restaurant?: object, menus?: object[], hasCategories?: boolean, hasProducts?: boolean, qrGenerated?: boolean, visitedStepIds?: string[] }} TourContext */

export const TOUR_EXPAND_MENU_EVENT = "tour:expand-menu";

export const ONBOARDING_TOUR_MODULES = [
  {
    id: "getting-started",
    titleKey: "tourModuleGettingStarted",
    descKey: "tourModuleGettingStartedDesc",
    icon: "fa-rocket",
    isComplete: (ctx) => ctx.visitedStepIds?.includes("gs-setup-guide"),
    steps: [
      {
        id: "gs-welcome",
        route: "/dashboard",
        target: '[data-tour="tour-page-dashboard"]',
        titleKey: "tourStepGsWelcomeTitle",
        bodyKey: "tourStepGsWelcomeBody",
        placement: "bottom",
      },
      {
        id: "gs-start-now",
        route: "/dashboard",
        target: '[data-tour="tour-nav-start-now"]',
        titleKey: "tourStepGsStartNowTitle",
        bodyKey: "tourStepGsStartNowBody",
        placement: "right",
      },
      {
        id: "gs-setup-guide",
        route: "/dashboard",
        target: '[data-tour="tour-nav-setup-guide"]',
        titleKey: "tourStepGsGuideTitle",
        bodyKey: "tourStepGsGuideBody",
        placement: "right",
      },
    ],
  },
  {
    id: "account",
    titleKey: "tourModuleAccount",
    descKey: "tourModuleAccountDesc",
    icon: "fa-store",
    isComplete: (ctx) =>
      Boolean(
        ctx.restaurant?.nameRes?.trim() &&
          ctx.restaurant?.country?.trim() &&
          ctx.restaurant?.city?.trim() &&
          ctx.restaurant?.logo
      ),
    steps: [
      {
        id: "account-nav",
        route: "/dashboard",
        target: '[data-tour="tour-nav-restaurant-info"]',
        titleKey: "tourStepAccountNavTitle",
        bodyKey: "tourStepAccountNavBody",
        placement: "right",
        expandMenuKey: "restaurant",
        expandMenuKey: "restaurant",
      },
      {
        id: "account-page",
        route: "/app-profile",
        target: '[data-tour="tour-page-profile"]',
        titleKey: "tourStepAccountPageTitle",
        bodyKey: "tourStepAccountPageBody",
        placement: "bottom",
      },
    ],
  },
  {
    id: "menu-builder",
    titleKey: "tourModuleMenuBuilder",
    descKey: "tourModuleMenuBuilderDesc",
    icon: "fa-magic",
    isComplete: (ctx) => (ctx.menus?.length || 0) > 0,
    steps: [
      {
        id: "menu-start-now",
        route: "/dashboard",
        target: '[data-tour="tour-nav-start-now"]',
        titleKey: "tourStepMenuStartTitle",
        bodyKey: "tourStepMenuStartBody",
        placement: "right",
      },
      {
        id: "menu-list",
        route: "/menu",
        target: '[data-tour="tour-page-menus"]',
        titleKey: "tourStepMenuListTitle",
        bodyKey: "tourStepMenuListBody",
        placement: "bottom",
      },
    ],
  },
  {
    id: "kitchen",
    titleKey: "tourModuleKitchen",
    descKey: "tourModuleKitchenDesc",
    icon: "fa-utensils",
    isComplete: (ctx) => ctx.hasCategories && ctx.hasProducts,
    steps: [
      {
        id: "kitchen-nav",
        route: "/dashboard",
        target: '[data-tour="tour-nav-kitchen"]',
        expandMenuKey: "kitchen",
        titleKey: "tourStepKitchenNavTitle",
        bodyKey: "tourStepKitchenNavBody",
        placement: "right",
      },
      {
        id: "kitchen-categories",
        route: "/categories",
        target: '[data-tour="tour-page-categories"]',
        titleKey: "tourStepKitchenCategoriesTitle",
        bodyKey: "tourStepKitchenCategoriesBody",
        placement: "bottom",
      },
      {
        id: "kitchen-products",
        route: "/products",
        target: '[data-tour="tour-page-products"]',
        titleKey: "tourStepKitchenProductsTitle",
        bodyKey: "tourStepKitchenProductsBody",
        placement: "bottom",
      },
    ],
  },
  {
    id: "qr",
    titleKey: "tourModuleQr",
    descKey: "tourModuleQrDesc",
    icon: "fa-qrcode",
    isComplete: (ctx) => Boolean(ctx.qrGenerated),
    steps: [
      {
        id: "qr-nav",
        route: "/dashboard",
        target: '[data-tour="tour-nav-qrcode"]',
        titleKey: "tourStepQrNavTitle",
        bodyKey: "tourStepQrNavBody",
        placement: "right",
        expandMenuKey: "restaurant",
        expandMenuKey: "restaurant",
      },
      {
        id: "qr-page",
        route: "/app-qrcode",
        target: '[data-tour="tour-page-qrcode"]',
        titleKey: "tourStepQrPageTitle",
        bodyKey: "tourStepQrPageBody",
        placement: "bottom",
      },
    ],
  },
  {
    id: "operations",
    titleKey: "tourModuleOperations",
    descKey: "tourModuleOperationsDesc",
    icon: "fa-cash-register",
    isComplete: (ctx) =>
      ctx.visitedStepIds?.includes("ops-reservations") &&
      ctx.visitedStepIds?.includes("ops-orders"),
    steps: [
      {
        id: "ops-nav",
        route: "/dashboard",
        target: '[data-tour="tour-nav-pos"]',
        expandMenuKey: "pos",
        titleKey: "tourStepOpsNavTitle",
        bodyKey: "tourStepOpsNavBody",
        placement: "right",
      },
      {
        id: "ops-orders",
        route: "/orders",
        target: '[data-tour="tour-page-orders"]',
        titleKey: "tourStepOpsOrdersTitle",
        bodyKey: "tourStepOpsOrdersBody",
        placement: "bottom",
      },
      {
        id: "ops-reservations",
        route: "/reservations",
        target: '[data-tour="tour-page-reservations"]',
        titleKey: "tourStepOpsReservationsTitle",
        bodyKey: "tourStepOpsReservationsBody",
        placement: "bottom",
      },
    ],
  },
  {
    id: "support",
    titleKey: "tourModuleSupport",
    descKey: "tourModuleSupportDesc",
    icon: "fa-headset",
    isComplete: (ctx) => ctx.visitedStepIds?.includes("support-claims"),
    steps: [
      {
        id: "support-nav",
        route: "/dashboard",
        target: '[data-tour="tour-nav-support"]',
        expandMenuKey: "support",
        titleKey: "tourStepSupportNavTitle",
        bodyKey: "tourStepSupportNavBody",
        placement: "right",
      },
      {
        id: "support-claims",
        route: "/client-reclamations",
        target: '[data-tour="tour-page-claims"]',
        titleKey: "tourStepSupportClaimsTitle",
        bodyKey: "tourStepSupportClaimsBody",
        placement: "bottom",
      },
    ],
  },
  {
    id: "events",
    titleKey: "tourModuleEvents",
    descKey: "tourModuleEventsDesc",
    icon: "fa-bullhorn",
    isComplete: (ctx) => ctx.visitedStepIds?.includes("events-page"),
    steps: [
      {
        id: "events-nav",
        route: "/dashboard",
        target: '[data-tour="tour-nav-events"]',
        titleKey: "tourStepEventsNavTitle",
        bodyKey: "tourStepEventsNavBody",
        placement: "right",
      },
      {
        id: "events-page",
        route: "/events",
        target: '[data-tour="tour-page-events"]',
        titleKey: "tourStepEventsPageTitle",
        bodyKey: "tourStepEventsPageBody",
        placement: "bottom",
      },
    ],
  },
];

export function getTourModuleById(moduleId) {
  return ONBOARDING_TOUR_MODULES.find((module) => module.id === moduleId) || null;
}

export function getModuleStepStatus(module, ctx) {
  const totalSteps = module.steps.length;
  const viewed = module.steps.filter((step) => ctx.visitedStepIds?.includes(step.id)).length;
  const complete = module.isComplete?.(ctx) || viewed >= totalSteps;
  return {
    totalSteps,
    viewedSteps: viewed,
    complete,
    inProgress: viewed > 0 && !complete,
  };
}
